import { useEffect } from 'react';
import { useQueryParam } from 'use-query-params';
import { Link } from 'react-router-dom';
import { css } from 'twin.macro';

import { useSuccessfulLogin } from '@auth_module/hooks/useSuccessfulLogin';
import { Layout } from '@auth_module/components/Layout';
import { withTitle } from '@hoc/withTitle';
import { RegisterDirectForm } from '@auth_module/components/RegisterDirectForm';
import { PromotionHubTermsOfServiceModal } from '@auth_module/components/PromotionHubTermsOfServiceModal';
import { URL_KEY } from '@auth_module/constants/urlKeys';
import { STORAGE_KEY } from '@auth_module/constants/storageKeys';
import {
  REGISTRATION_STORAGE_KEY,
  REGISTRATION_URL_PARAM,
  registration_contexts,
} from '@account_module/constants/registrationCtxKeys';
import { SounderLogo } from '@icons/SounderLogo';
import registerGraphic from '@assets/images/register-graphic.svg';

const backgroundImage = css`
  background-image: url(${registerGraphic});
`;

const _RegisterDirectPage = () => {
  const { handleSuccessLogin } = useSuccessfulLogin({ navigateTo: '/email/verify' });
  const [planIdURLParam] = useQueryParam(URL_KEY.promohub_plan_id);
  const [regCtxURLParam] = useQueryParam(REGISTRATION_URL_PARAM.CTX); // The registration context determines which page the user will land on after email verification.
  const storagePlanId: string | undefined = JSON.parse(
    window.localStorage.getItem(STORAGE_KEY.promohub_plan_id) as string
  );

  useEffect(() => {
    if (planIdURLParam && storagePlanId !== planIdURLParam) {
      window.localStorage.setItem(STORAGE_KEY.promohub_plan_id, JSON.stringify(planIdURLParam));
    }

    if (regCtxURLParam && registration_contexts.includes(regCtxURLParam as string)) {
      window.localStorage.setItem(REGISTRATION_STORAGE_KEY.CTX, JSON.stringify(regCtxURLParam));
    }
  }, [planIdURLParam, storagePlanId, regCtxURLParam]);

  return (
    <>
      <Layout
        tw='md:top-[calc(50% - 296px)] md:max-w-[536px]'
        backgroundCss={backgroundImage}
        header={
          <div tw='absolute top-0 left-0 w-full flex justify-between items-center z-30 px-[48px] pt-[30px]'>
            <SounderLogo tw='w-[31px] h-[42px] fill-accent-1 md:fill-text-and-icon-invert' />
            <div tw='flex gap-[12px] items-center'>
              <Link
                to='/login'
                tw='flex h-[40px] px-[19px] justify-center items-center rounded bg-[rgba(255, 255, 255, 0.10)] text-[16px] font-semibold text-accent-1 md:text-text-and-icon-invert cursor-pointer no-underline'>
                Log In
              </Link>
            </div>
          </div>
        }>
        <RegisterDirectForm handleSuccessLogin={handleSuccessLogin} />
      </Layout>

      <PromotionHubTermsOfServiceModal />
    </>
  );
};

export const RegisterDirectPage = withTitle(_RegisterDirectPage, 'auth.register_page.title');
